import React from "react";

import { Link } from "react-router-dom";

const Component29 = () => {
  return (
    <>
    
    <div className="dhiwise-navigation">
      <h1>Homepage</h1>
      <p className="headline">
        This project was generated By{" "}
        <a href="https://www.dhiwise.com">Dhiwise</a>. Quickly use below links
        to navigate through all pages.
      </p>
      <ul>
        <li>
          <Link to="/">LandingPage</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/projectdetails">Project Details</Link>
        </li>
        <li>
          <Link to="/agentlist">AgentList</Link>
        </li>
        <li>
          <Link to="/contactpage">ContactPage</Link>
        </li>
        <li>
          <Link to="/blogpage">BlogPage</Link>
        </li>
        <li>
          <Link to="/blogdetails">BlogDetails</Link>
        </li>
        <li>
          <Link to="/error">Error</Link>
        </li>
        <li>
          <Link to="/faq">FAQ</Link>
        </li>
        <li>
          <Link to="/privacypolicy">PrivacyPolicy</Link>
        </li>
        <li>
          <Link to="/license">License</Link>
        </li>
        <li>
          <Link to="/components">Components</Link>
        </li>
      </ul>
    </div>
    </>
  );
};

export default Component29;
